import React, { Component } from 'react'
import CustomTable from '../../../elements/Table/CustomTable'
import { Link } from 'react-router-dom'
import { dateFormat, strVal } from '../../../modules/Utils'
import moment from 'moment'
import Status from '../../../elements/Status'
import DateCell from '../../../elements/Table/Cells/DateCell'
import MoneyCell from '../../../elements/Table/Cells/MoneyCell'
import StatusCell from '../../../elements/Table/Cells/StatusCell'
import StatusFilter, { statusFilterMethod } from '../../../components/Sales/Orders/TableComponents/StatusFilter'
import InvoicedFilter, { invoicedQtyFilterMethod } from '../../../components/Sales/Orders/TableComponents/InvoicedFilter'

class List extends Component {
  componentDidMount() {
    this.props.fetchOrderLines()
  }

  columns = [
    {
      Header: 'Order',
      accessor: 'order.code',
      Cell: ({ original, value }) => (
        <Link
          to={{
            pathname: `/clients/orders/${strVal(original, 'order._key')}/update`,
          }}>
          {value}
        </Link>
      ),
    },
    {
      Header: 'Date',
      accessor: 'order.date',
      Cell: DateCell,
    },
    {
      Header: 'Line No',
      accessor: 'no',
      width: 100,
    },
    {
      Header: 'Name',
      accessor: 'name',
      width: 300,
    },
    {
      Header: 'Pick up Date',
      accessor: 'booking.pickup.date',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Drop off',
      accessor: 'booking.dropoff.date',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Description',
      accessor: 'description',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Quantity',
      accessor: 'unit',
      Cell: MoneyCell,
    },
    {
      Header: 'Invoiced Quantity',
      accessor: 'invoiced',
      Cell: MoneyCell,
      Filter: InvoicedFilter,
      filterMethod: invoicedQtyFilterMethod,
      hideable: true,
    },
    {
      Header: 'UoM',
      accessor: 'uom',
    },
    {
      Header: 'Rate',
      accessor: 'rate',
      hideable: true,
      hideDefault: true,
      Cell: MoneyCell,
    },
    {
      Header: 'Tax rate',
      accessor: 'tax.rate',
      hideable: true,
      hideDefault: true,
      Cell: MoneyCell,
    },
    {
      Header: 'Total',
      accessor: 'amount.net',
      hideable: true,
      hideDefault: true,
      Cell: MoneyCell,
    },

    {
      Header: 'Client',
      accessor: 'order.client.fn',
      hideable: true,
      hideDefault: true,
      width: 300,
    },
    {
      Header: 'Account',
      accessor: 'order.contract.code',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Currency',
      accessor: 'order.currency',
      hideable: true,
      hideDefault: true,
      style: { textAlign: 'center' },
    },
    {
      Header: 'Amount',
      accessor: 'order.subtotal.net',
      hideable: true,
      hideDefault: true,
      style: { textAlign: 'right' },
      Cell: MoneyCell,
    },
    {
      Header: 'Company',
      accessor: 'order.company.fn',
      hideDefault: true,
      hideable: true,
      width: 400,
    },
    {
      Header: 'Invoiced Date',
      accessor: 'order.invoicing.date',
      Cell: ({ value }) => value && dateFormat(moment(value)),
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'CPO NO',
      accessor: 'order.cpo.no',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Reference NO',
      accessor: 'order.reference.no',
      hideable: true,
      hideDefault: true,
    },

    {
      Header: 'Status',
      accessor: 'order.status',
      width: 150,
      Cell: StatusCell,
      filterMethod: statusFilterMethod,
      Filter: StatusFilter,
    },
  ]

  render() {
    const { orderLinesList, fetchOrderLines, fetchingOrderLines } = this.props
    return (
      <CustomTable
        isFilterable={true}
        columns={this.columns}
        data={orderLinesList}
        fetch={fetchOrderLines}
        fetching={fetchingOrderLines}
        defaultPageSize={20}
        show={{ extraColumns: true }}
        // pivotBy={['order.code']}
      />
    )
  }
}

List.propTypes = {}
List.defaultProps = {}

export default List
